import { Risk } from '../types/risk';

export const sampleRisks: Risk[] = [
  {
    id: 'r1',
    dealId: 'deal-1',
    title: 'Technology Integration Risk',
    description: 'Potential compatibility issues between core systems',
    category: 'operational',
    impact: 'high',
    probability: 'medium',
    status: 'identified',
    mitigation: 'Detailed technical assessment and integration planning',
    owner: 'Michael Chen',
    dueDate: '2024-05-15',
    createdAt: '2024-03-01',
    updatedAt: '2024-03-01'
  },
  {
    id: 'r2',
    dealId: 'deal-1',
    title: 'Regulatory Approval Delay',
    description: 'Potential delay in obtaining required regulatory approvals',
    category: 'regulatory',
    impact: 'high',
    probability: 'high',
    status: 'monitoring',
    mitigation: 'Early engagement with regulatory bodies',
    owner: 'Sarah Johnson',
    dueDate: '2024-06-01',
    createdAt: '2024-03-01',
    updatedAt: '2024-03-10'
  },
  {
    id: 'r3',
    dealId: 'deal-2',
    title: 'Market Share Loss',
    description: 'Risk of losing market share during integration period',
    category: 'strategic',
    impact: 'high',
    probability: 'medium',
    status: 'identified',
    mitigation: 'Customer retention program and communication strategy',
    owner: 'Emily Rodriguez',
    dueDate: '2024-07-15',
    createdAt: '2024-03-05',
    updatedAt: '2024-03-05'
  }
];